import { Builder } from '@builder.io/react';

import { ActiveCampaignWrapperWithChildren } from './active-campaign-wrapper';

Builder.registerComponent(ActiveCampaignWrapperWithChildren, {
  name: 'ActiveCampaignWrapper',
  noWrap: true,
  inputs: [
    {
      name: 'forceShow',
      type: 'boolean',
      defaultValue: false,
      friendlyName: 'Force Show',
      helperText: 'Show the component even when there is no phone campaign',
    },
  ],
  canHaveChildren: true,
});
